import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

const ROTATING_WORDS = ["data center", "colocation", "cloud hosting", "managed IT"];

const RotatingWord = () => {
  const [index, setIndex] = useState(0);
  const prefersReducedMotion = useReducedMotion();

  useEffect(() => {
    // A headline that keeps rewriting itself is the clearest case of
    // motion to suppress — hold on the first word instead.
    if (prefersReducedMotion) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % ROTATING_WORDS.length);
    }, 2400);
    return () => clearInterval(interval);
  }, [prefersReducedMotion]);

  if (prefersReducedMotion) {
    return (
      <span className="inline-block whitespace-nowrap text-[var(--website-secondary-color)]">
        {ROTATING_WORDS[0]}
      </span>
    );
  }

  return (
    <span
      className="relative inline-block text-center"
      style={{ minWidth: "7.5ch" }}
    >
      <AnimatePresence mode="wait">
        <motion.span
          key={ROTATING_WORDS[index]}
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -24, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="inline-block whitespace-nowrap text-[var(--website-secondary-color)]"
        >
          {ROTATING_WORDS[index]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

export default RotatingWord;
